<template>
  <div>
    <app-cells><h1 class="title">Altura Reimbursement</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'AlturaReimbursementLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-altura-reimbursement-payments', label: 'Payments'},
        { name: 'finance-altura-reimbursement-groups', label: 'Groups'},
      ],
    }
  },
}
</script>
